import {
  getMsalSimDocumentsInstance,
  loginRequest,
} from "../../authentication/authConfig";
import { Button } from "react-bootstrap";

export const SignInButton = () => {
  const handleLogin = () => {
    getMsalSimDocumentsInstance()
      .loginRedirect(loginRequest)
      .catch((error: any) => console.log(error));
  };

  return (
    <>
      <Button className="custom-margin" onClick={() => handleLogin()}>
        Sign in
      </Button>
    </>
  );
};
